import { Contract } from "./contract.model";

interface IAchRecord {
    achRecordId: string; 
    bankName: string; 
    routingNumber: string; 
    accountNumber: string;  
    userId: string; 
    createDateUtc: Date;
    setupComplete: boolean;
    contractModel: Contract;
}
export class ACHRecord {
    public achRecordId: string; 
    public bankName: string; 
    public routingNumber: string; 
    public accountNumber: string;  
    public userId: string;  
    public createDateUtc: Date;
    public setupComplete: boolean;
    public contractModel: Contract;

    constructor();
    constructor(object: IAchRecord)
    constructor(object?: any) {
        this.achRecordId = object && object.achRecordId || null;
        this.bankName = object && object.bankName || null;
        this.routingNumber = object && object.routingNumber || null;
        this.accountNumber = object && object.accountNumber || null;
        this.userId = object && object.userId || null;
        this.createDateUtc = object && object.createDateUtc || null;
        this.setupComplete = object && object.setupComplete || null;
        this.contractModel = object && object.contractModel || null;
    }
}